import type { FC } from 'react';
import React from 'react';
import { formatCurrency } from 'src/utils/stringUtils';
import styles from './departureList.module.css';

export interface IDeparture {
  text: string;
  link: string;
  price: number | string;
}

interface Props {
  departureList: IDeparture[];
}

export const DepartureList: FC<Props> = ({ departureList }) => (
  <div className={styles.subContainer}>
    {departureList.map((dep) => (
      <div className={styles.wrapper} key={dep.link}>
        <a className={styles.anchor} href={dep.link}>
          {dep.text}
        </a>
        <span className={styles.price}>{`от ${formatCurrency(
          dep.price,
        )}`}</span>
      </div>
    ))}
  </div>
);
